import { endOfDay, max as maxDate, startOfDay } from 'date-fns'
import { useFormContext, useWatch } from 'react-hook-form'

import {
  METRICS_EARLIEST_DATE,
  TimePeriod,
} from 'components/reports/Metrics/constants/ExceptionMetrics'
import { NetworkGrowthInputDtoInput } from 'generated/graphql'
import { resolvePeriod } from 'helpers/metricsPeriod.helpers'

import { NetworkGrowthFilterValues } from './NetworkGrowthFilterCriteria'

interface QueryInput {
  start: Date | null
  end: Date | null
  hasValidRange: boolean
  isCustom: boolean
  input: NetworkGrowthInputDtoInput
}

export const useNetworkGrowthQueryInput = (): QueryInput => {
  const { control } = useFormContext<NetworkGrowthFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const vehicleType = useWatch({ control, name: 'vehicleType' })

  const isCustom = period === ('custom' as TimePeriod)

  const hasCompleteCustomRange = isCustom && customStart != null && customEnd != null

  const { start: rawStart, end } = hasCompleteCustomRange
    ? { start: startOfDay(customStart), end: endOfDay(customEnd) }
    : resolvePeriod(period === 'custom' ? 'last30' : period)

  const start = rawStart ? maxDate([rawStart, METRICS_EARLIEST_DATE]) : null

  const hasValidRange = start != null && end != null && start <= end

  return {
    start,
    end,
    hasValidRange,
    isCustom,
    input: {
      start: start ?? new Date(),
      end: end ?? new Date(),
      vehicleType,
    },
  }
}
